var URL_ROOT = '/';

function EventEmitter() {
    var _listeners = [];

    function on(listener) {
        _listeners.push(listener);
    }

    function off(listenerToRemove) {
        _listeners = _listeners.filter(function (listener) {
            return listener !== listenerToRemove;
        });
    }

    function trigger(event) {
        _listeners.forEach(function (listener) {
            listener(event);
        });
    }

    return {
        on: on,
        off: off,
        trigger: trigger
    };
}

export const storeUtils = {
    URL_ROOT,
    EventEmitter
};
